export default __webpack_public_path__ + "3994d0d5b96bdbc1f3c0027819dc0435.svg";